import React from 'react';
import HRLeavePage from '../../pages/hr/leave-management';
import ProtectedRoute from '../protected';

export const HRLeaveRoutes = [
  <ProtectedRoute exact path='/leave/applications' component={HRLeavePage} />,
  <ProtectedRoute exact path='/leave/types' component={HRLeavePage} />,
  <ProtectedRoute exact path='/leave/settings' component={HRLeavePage} />,
];